import { connect } from 'react-redux'
import { getProjects } from 'actions/overview_actions'

export default connect((state) => ({
  mspWorkflows: state.overview?.mspWorkflows || [],
  projectGroups: state.overview?.projectGroups || [],
  projects: state.overview?.projects || []
}),{ getProjects })
